import { render } from "./PageTeam.vue?vue&type=template&id=023718ca&scoped=true"
import script from "./PageTeam.vue?vue&type=script&lang=js"
export * from "./PageTeam.vue?vue&type=script&lang=js"

import "./PageTeam.vue?vue&type=style&index=0&id=023718ca&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023718ca"]])

export default __exports__